import { CreateRoadsideJobRequest } from '@/interfaces/entities/jor-create-rsa-job.interface';
import { RequestRoadsideAssistanceDetailsPersonal } from '@/interfaces/pages/request-roadside-assistance.interface';

export const YOUR_DETAILS_VEHICLE_DETAILS_STEP_ID = 'yourdetailsvehicledetails';
export const REQUEST_ROADSIDE_ASSISTANCE = 'Request roadside assistance';

// Analytics
export const YOUR_DETAILS_ANALYTICS_STEP_NAME = 'Your details';
export const GET_MEMBERSHIP_CARD_ANALYTICS_STEP1_NAME = 'Get membership card number';
export const GET_MEMBERSHIP_CARD_ANALYTICS_STEP2_NAME = 'Get membership card number - send member number';
export const GET_MEMBERSHIP_CARD_ANALYTICS_STEP3_NAME = 'Get membership card number- membership number sent';
export const GET_DETAILS_ANALYTICS_VERIFICATION_STATE_INITIAL_NAME = 'Help us identify you';
export const GET_DETAILS_ANALYTICS_VERIFICATION_STATE_AUTH_FACTORS_LOADED_NAME = "Verify it's you with a code";
export const GET_DETAILS_ANALYTICS_VERIFICATION_STATE_OTP_SEND_NAME = "Verify it's your with a code - code sent";
export const GET_DETAILS_ANALYTICS_VERIFICATION_STATE_COMPLETED_NAME = "Thank you, we've got your membership number";
export const VEHICLE_DETAILS_ANALYTICS_STEP_NAME = 'We need some additional information';
export const BREAKDOWN_LOCATION_ANALYTICS_STEP_NAME = 'Breakdown details';
export const BREAKDOWN_CAUSE_ANALYTICS_STEP_NAME = 'Breakdown cause';
export const YOUR_COMMENTS_ANALYTICS_STEP_NAME = 'Your comments';
export const REVIEW_ANALYTICS_STEP_NAME = 'Review';
export const CONFIRMATION_ANALYTICS_STEP_NAME = 'FormCompleted';

export default {} as const;

export async function createRsaJobHtmlRequest(
  requestRoadsideAssistanceDetails: RequestRoadsideAssistanceDetailsPersonal
): Promise<Partial<CreateRoadsideJobRequest>> {
  const baseRequest = createBaseRsaJob(requestRoadsideAssistanceDetails, 'HTML');

  return {
    ...baseRequest,
  } as CreateRoadsideJobRequest;
}

function createBaseRsaJob(
  requestRoadsideAssistanceDetails: RequestRoadsideAssistanceDetailsPersonal,
  channel: string
): Partial<CreateRoadsideJobRequest> {
  return {
    channel: channel,
    comments: [requestRoadsideAssistanceDetails.comments],
    triageAnswers: {
      SAFE_LOCATION: ['NO'],
      BREAKDOWN_REASON: [requestRoadsideAssistanceDetails.breakdownCause],
    },
    membership: {
      membershipCardNumber: requestRoadsideAssistanceDetails.membershipCardNumber,
      contact: {
        phone: requestRoadsideAssistanceDetails.phoneNumber,
      },
    },
    vehicle: {
      colour: requestRoadsideAssistanceDetails.vehicle?.colour,
      make: requestRoadsideAssistanceDetails.vehicle?.make,
      model: requestRoadsideAssistanceDetails.vehicle?.model,
      registration: requestRoadsideAssistanceDetails.registrationNumber,
      buildYear: parseInt(requestRoadsideAssistanceDetails.vehicle?.buildYear as any, 10),
      location: {
        latitude: requestRoadsideAssistanceDetails.breakdownLocationLatitude,
        longitude: requestRoadsideAssistanceDetails.breakdownLocationLongitude,
        comment: requestRoadsideAssistanceDetails.breakdownLocationAddress,
      },
    },
  } as unknown as Partial<CreateRoadsideJobRequest>;
}
